import { render } from "./SidebarAccountOptions.vue?vue&type=template&id=4149f65f"
import script from "./SidebarAccountOptions.vue?vue&type=script&lang=js"
export * from "./SidebarAccountOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__